<nz-drawer
	[nzClosable]="false"
	[(nzVisible)]="filtersDrawer"
	nzPlacement="right"
	(nzOnClose)="filtersDrawer = false"
	[nzTitle]="'common_filters-title' | translate"
	nzWidth="300"
>
	<hpf-role-permission-filters
		[searchParams]="searchParams"
		[resetPage]="true"
	></hpf-role-permission-filters>
</nz-drawer>
<hpf-role-permission-list-top-bar
	[title]="'role-permission_common_name' | translate"
	(filterEvent)="filtersDrawer = true"
	[searchParams]="searchParams"
	(createEvent)="onCreate()"
	[createButton]="'common_create' | translate"
	[showQuickSearch]="true"
	[quickSearchTooltip]="
		'common_search-by' | translate: { list: 'collection' }
	"
	[quickSearchPlaceholder]="'common_quick-search' | translate"
	[showAdvancedSearch]="true"
></hpf-role-permission-list-top-bar>
<div class="container-fluid px-5">
	<div class="row my-5">
		<div class="col-12">
			<hpf-role-permission-table
				[searchParams]="searchParams"
				[enableMultiSelect]="true"
				[showActions]="true"
				(select)="onSelect($event)"
			></hpf-role-permission-table>
		</div>
	</div>
</div>
